import React from 'react';
import { useSelector } from 'react-redux';
import MaintenanceContainer from 'containers/MaintenanceContainer';
import ErrorAPIConnection from 'components/commons/ErrorAPIConnection';
import ScrollToTop from 'containers/ScrollToTop';
import { NotificationContainer } from 'react-notifications';
import HeaderContainer from 'containers/HeaderContainer';
import NavigationContainer from 'containers/NavigationContainer';
import ModalManager from 'containers/ModalManager';
import Cart from 'components/commons/Cart';
import Whatsapp from 'components/commons/Whatsapp';
import Footer from 'components/main/Footer';

const AppContent = () => {
  const maintenance = useSelector(state => state.app.maintenance);

  if (maintenance.inhabilitado) {
    return <MaintenanceContainer maintenance={maintenance} />;
  }

  return (
    <>
      <ErrorAPIConnection />
      <ScrollToTop />
      <NotificationContainer />
      <HeaderContainer />
      <div className="container-page">
        <NavigationContainer />
        <ModalManager />
        <Cart />
        <Whatsapp />
        <Footer />
      </div>
    </>
  );
};

export default AppContent;
